import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaLink } from 'react-icons/fa';

const ShipmentLabel = ({ caseId }) => {
  const [shipmentTrackingUrl, setShipmentTrackingUrl] = useState('');
  const [isEditingUrl, setIsEditingUrl] = useState(false);
  const [urls, setUrls] = useState([]);

  // API base URL
  const API_BASE_URL = 'https://hms.backend.hiragroupcloud.com/api/cases';

  useEffect(() => {
    const fetchShipmentUrls = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/${caseId}/shipment`);
        setUrls(response.data.shipmentTrackingUrls || []);
      } catch (error) {
        console.error("❌ Error fetching shipment URLs:", error);
      }
    };

    fetchShipmentUrls();
  }, [caseId]);

  const saveUrl = async () => {
    const urlToNavigate = shipmentTrackingUrl.trim();
    if (!urlToNavigate) return;

    try {
      await axios.put(`${API_BASE_URL}/${caseId}/shipment`, { url: urlToNavigate });
      setUrls([...urls, urlToNavigate]);
      setShipmentTrackingUrl('');
      setIsEditingUrl(false);
    } catch (error) {
      console.error("❌ Error saving shipment URL:", error);
    }
  };

  const removeUrl = async (urlToRemove) => {
    try {
      await axios.put(`${API_BASE_URL}/${caseId}/shipment/remove`, { url: urlToRemove });
      setUrls(urls.filter(url => url !== urlToRemove));
    } catch (error) {
      console.error("❌ Error removing shipment URL:", error);
    }
  };

  return (
    <div style={{ padding: '15px', fontFamily: 'Arial, sans-serif', color: '#333' }}>
      <p style={{ fontWeight: 'bold', fontSize: '16px' }}>Shipment Tracking:</p>

      {isEditingUrl ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', alignItems: 'flex-start' }}>
          <input
            type="text"
            placeholder="Enter tracking URL"
            value={shipmentTrackingUrl}
            onChange={(e) => setShipmentTrackingUrl(e.target.value)}
            style={{
              width: '100%',
              maxWidth: '400px',
              padding: '8px', 
              fontSize: '14px',
              border: '1px solid gray', 
              borderRadius: '6px'
            }}
          />
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={saveUrl}
              style={{
                padding: '8px 12px', 
                fontSize: '14px', 
                border: 'none',
                backgroundColor: '#004aad', 
                color: 'white',
                borderRadius: '6px', 
                cursor: 'pointer', 
                fontWeight: 'bold'
              }}
            >
              Save
            </button>
            <button
              onClick={() => setIsEditingUrl(false)}
              style={{
                padding: '8px 12px', 
                fontSize: '14px', 
                border: '1px solid #ccc',
                backgroundColor: 'white', 
                color: '#333',
                borderRadius: '6px', 
                cursor: 'pointer', 
                fontWeight: 'bold'
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <div
          onClick={() => setIsEditingUrl(true)}
          style={{
            marginTop: '10px',
            cursor: 'pointer',
            backgroundColor: '#004aad',
            color: 'white',
            padding: '8px',
            borderRadius: '6px',
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "fit-content",
            gap: '8px'
          }}
        >
          <FaLink style={{ fontSize: '18px', color: 'white' }} />
          <span>Add Tracking URL</span>
        </div>
      )}

      <div id="urls" style={{ marginTop: '10px' }}>
        {urls.map((url, index) => (
          <div key={index} style={{
            display: 'flex', 
            alignItems: 'center', 
            gap: '10px', 
            marginTop: '5px',
            padding: '8px',
            backgroundColor: '#f5f5f5',
            borderRadius: '6px'
          }}>
            <a 
              href={url} 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{
                textDecoration: 'none', 
                color: '#004aad', 
                fontWeight: '500',
                flex: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
              title={url}
            >
              {url}
            </a>
            <button
              onClick={() => removeUrl(url)}
              style={{
                padding: '6px 10px', 
                fontSize: '12px', 
                border: 'none',
                backgroundColor: '#d9534f', 
                color: 'white',
                borderRadius: '6px', 
                cursor: 'pointer', 
                fontWeight: 'bold'
              }}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShipmentLabel;